/**
 * Modal global de upload de fatura (drag-and-drop com dragCounterRef para evitar pisca em filhos): envia o PDF a POST /extract-invoices, mostra a prévia extraída para conferência e só então confirma a gravação. Códigos de erro 2001-2004/1101/1103 mapeados em utils/invoiceUploadError.
 */
import React from 'react';

import { Modal } from 'ui/modal/modal.ui';

import { useAppDispatch, useAppSelector } from 'store/hooks';

import { setModalInvoiceState } from 'store/modal_invoice/modal_invoice.slice';
import { selectModalInvoiceState } from 'store/modal_invoice/modal_invoice.selector';
import { setConsumerUnitRefresh } from 'store/consumer_unit/consumer_unit.slice';
import { setInvoiceRefresh } from 'store/invoice/invoice.slice';

import { SelectInvoice } from './components/select-invoice/select-invoice.component';
import { SaveInvoice } from './components/save-invoice/save-invoice.component';

export const ModalInvoice = () => {
  const dispatch = useAppDispatch();

  const modalState = useAppSelector(selectModalInvoiceState);

  React.useEffect(() => {
    return () => {
      dispatch(setInvoiceRefresh({ refresh: true }));
    };
  }, [dispatch]);

  // Fechar mantém o usuário na tela de onde abriu o modal (nov/2026): o modal é
  // global e antes sempre levava ao Dashboard, perdendo o lugar.
  const handleClose = () => {
    dispatch(setInvoiceRefresh({ refresh: true }));
    dispatch(setModalInvoiceState({ modalState: 'hidden' }));
  };

  return (
    <Modal
      show={modalState !== 'hidden'}
      title="Importar conta de luz"
      close={handleClose}
    >
      {modalState === 'select_invoice' && <SelectInvoice />}
      {modalState === 'save_invoice' && <SaveInvoice />}
    </Modal>
  );
};
